import colors from 'vuetify/es5/util/colors';
import { Theme, VuetifyThemeVariant } from 'vuetify/types/services/theme';

// Any color names added to theme will need to be added to this interface
interface IExtendedTheme extends VuetifyThemeVariant {
    charcoal: string;
    peach: string;
    yellow: string;
}
export default {
    dark: false,
    themes: {
        light: {
            primary: '#052e83', // blue
            primaryLight: '#007bff',
            secondary: '#00a4a0', // turquoise
            accent: '#e30513', // orange
            primaryAlprolix: '#250e62', // dark purple
            secondprimaryAlprolix: '#b7bf10',
            primaryEloctate: '#00467f', //
            secondaryEloctate: '#00bce4',
            secondaryAlprolix: '#4d4d4d',
            primaryJevatana: '#61a60e', // dark green
            secondprimaryEloctate: '#61a60e',
            primarySarclisa: '#fc6f5d', // sarclisa
            secondprimaryAltuviiio: '#1e2d5b',
            error: colors.red.lighten2,
            warning: colors.amber.lighten2,
            info: colors.lightBlue.lighten2,
            success: colors.green.lighten2,
            charcoal: '#444444',
            peach: '#fbb884',
            yellow: '#f2ee82',
            btnColor: '#052e83',
            btnColorHover: '#00a4a0',
            systemBarFont: '#1E2D5B',
            sanofiGold: '#CAAE7A',
            sanofiDarkGray: '#898a8d',
            shadeBlack: '#2B2B38',
        } as Partial<IExtendedTheme>,
        dark: {
            primary: '#052e83', // blue
            secondary: '#00a4a0', // turquoise
            accent: '#ff6900', // orange
            error: colors.red.darken2,
            warning: colors.amber.darken2,
            info: colors.lightBlue.darken2,
            success: colors.green.darken2,
            charcoal: '#444444',
            peach: '#fbb884',
            yellow: '#f2ee82',
        } as Partial<IExtendedTheme>,
    },
    options: {
        // inject color vars into html root element
        customProperties: true,
    },
} as Theme;
